import * as React from "react";
// import { pure } from 'recompose';
import * as Utils from "@Cyclope-Utils/index";
import * as cx from "classnames";
import * as Lodash from "lodash";
import OngletBurger from "@tunnel-components/@sharded/widgets/onglet-burger/component";
import * as Styled from "@tunnel-components/@sharded/@styled/styled";
import * as Enums from "@tunnel-enums/index";
/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    onglet,
    ongletActive,
    someTitle,
    incidenSound,
    audioBoolean,
    onSound,
    onClickOnglet,
    ongletBurger,
    onClickBurger,
    activeBurger,
    onClickOngletAction,
    ongletActiveAction,
  } = props;

  /** Attribué un rôle à l'utilisateur */
  const User = Utils.createdUserRoles();

  const navigationAuthorization: boolean = Utils.simpleAuthorizationIsAllowed(
    User,
    [Enums.AuthorizationRightsEnums.HOMEVIEWINCIDENTS]
  );
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */

  return (
    <div className="onglet-navigation">
      <span style={{ color: "black", cursor: "default" }}>{someTitle}</span>
      {Lodash.isArray(onglet) &&
        !Lodash.isUndefined(onglet) &&
        onglet.map((elem: any, index: number) => (
          <span
            className={cx("text-onglet", {
              "isVisible-active": true,
              isHidden: elem.title === "",
            })}
            key={index}
          >
            {!!elem.title && !!ongletActive && (
              <span
                className={cx("", {
                  "onglet-separator-active": ongletActive[index],
                  "onglet-pas-authorise": !navigationAuthorization,
                  "onglet--authorise": navigationAuthorization,
                })}
                onClick={
                  navigationAuthorization
                    ? onClickOnglet(elem.title, index)
                    : "undefined"
                }
              >
                {elem.title}
              </span>
            )}

            {!!elem.action && onClickOngletAction && ongletActiveAction && (
              <Styled.BreadBoxContainer
                className={
                  !!elem.action && !Lodash.isEmpty(elem.action)
                    ? "isVisible"
                    : ""
                }
                isVisible={true}
                style={{
                  width: "auto",
                  top: "18px",
                  minWidth: "170px",
                  fontSize: "15px",
                  padding: "5px",
                }}
              >
                {elem.action
                  .filter((element: any) => element !== "")
                  .map((title: string, increment: number) => (
                    <span
                      key={increment}
                      onClick={
                        navigationAuthorization
                          ? onClickOngletAction(title, increment, index)
                          : "undefined"
                      }
                      style={{
                        marginBottom: "5px",
                        paddingBottom: "5px",
                        borderBottom: "1px solid #007ADF",
                      }}
                      className={cx("", {
                        "onglet-separator-active":
                          navigationAuthorization &&
                          ongletActiveAction[increment],
                        "onglet-pas-authorise": !navigationAuthorization,
                        "onglet--authorise": navigationAuthorization,
                      })}
                    >
                      {title}
                    </span>
                  ))}
              </Styled.BreadBoxContainer>
            )}
          </span>
        ))}
      {ongletBurger && (
        <OngletBurger
          onClickBurger={onClickBurger}
          navigationAuthorization={navigationAuthorization}
          activeBurger={activeBurger}
        />
      )}
      {incidenSound && (
        <span className="burgerNavigationMenu">
          <div className="audio-bip-in">
            {audioBoolean && (
              <svg
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 93 93"
                onClick={onSound}
              >
                <path
                  fill="#007ADF"
                  d="M46.547,75.521c0,1.639-0.947,3.128-2.429,3.823c-0.573,0.271-1.187,0.402-1.797,0.402c-0.966,0-1.923-0.332-2.696-0.973
                                l-23.098-19.14H4.225C1.892,59.635,0,57.742,0,55.409V38.576c0-2.334,1.892-4.226,4.225-4.226h12.303l23.098-19.14
                                c1.262-1.046,3.012-1.269,4.493-0.569c1.481,0.695,2.429,2.185,2.429,3.823L46.547,75.521L46.547,75.521z M62.784,68.919
                                c-0.103,0.007-0.202,0.011-0.304,0.011c-1.116,0-2.192-0.441-2.987-1.237l-0.565-0.567c-1.482-1.479-1.656-3.822-0.408-5.504
                                c3.164-4.266,4.834-9.323,4.834-14.628c0-5.706-1.896-11.058-5.484-15.478c-1.366-1.68-1.24-4.12,0.291-5.65l0.564-0.565
                                c0.844-0.844,1.975-1.304,3.199-1.231c1.192,0.06,2.305,0.621,3.061,1.545c4.977,6.09,7.606,13.484,7.606,21.38
                                c0,7.354-2.325,14.354-6.725,20.24C65.131,68.216,64.007,68.832,62.784,68.919z M80.252,81.976
                                c-0.764,0.903-1.869,1.445-3.052,1.495c-0.058,0.002-0.117,0.004-0.177,0.004c-1.119,0-2.193-0.442-2.988-1.237l-0.555-0.555
                                c-1.551-1.55-1.656-4.029-0.246-5.707c6.814-8.104,10.568-18.396,10.568-28.982c0-11.011-4.019-21.611-11.314-29.847
                                c-1.479-1.672-1.404-4.203,0.17-5.783l0.554-0.555c0.822-0.826,1.89-1.281,3.115-1.242c1.163,0.033,2.263,0.547,3.036,1.417
                                c8.818,9.928,13.675,22.718,13.675,36.01C93.04,59.783,88.499,72.207,80.252,81.976z"
                />
              </svg>
            )}
            {!audioBoolean && (
              <svg
                version="1.1"
                id="Capa_1"
                x="0px"
                y="0px"
                viewBox="0 0 448 448"
                onClick={onSound}
              >
                <path
                  fill="#007ADF"
                  d="M352.021,16.075c0-6.08-3.52-11.84-8.96-14.4c-5.76-2.88-12.16-1.92-16.96,1.92l-141.76,112.96l167.68,167.68V16.075z"
                />
                <path
                  fill="#007ADF"
                  d="M443.349,420.747l-416-416c-6.24-6.24-16.384-6.24-22.624,0s-6.24,16.384,0,22.624l100.672,100.704h-9.376
                                c-9.92,0-18.56,4.48-24.32,11.52c-4.8,5.44-7.68,12.8-7.68,20.48v128c0,17.6,14.4,32,32,32h74.24l155.84,124.48
                                c2.88,2.24,6.4,3.52,9.92,3.52c2.24,0,4.8-0.64,7.04-1.6c5.44-2.56,8.96-8.32,8.96-14.4v-57.376l68.672,68.672
                                c3.136,3.136,7.232,4.704,11.328,4.704s8.192-1.568,11.328-4.672C449.589,437.131,449.589,427.019,443.349,420.747z"
                />
              </svg>
            )}
          </div>
        </span>
      )}
    </div>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  onglet: any[];
  ongletActive: boolean[];
  onClickOnglet: any;
  ongletBurger?: boolean;
  onClickBurger?: any;
  activeBurger?: any;
  onClickOngletAction?: any;
  ongletActiveAction?: boolean[];
  someTitle?: string;
  incidenSound?: boolean;
  audioBoolean?: boolean;
  onSound?: any;
}

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/onglet-navigation/component.tsx